module.exports = __webpack_public_path__ + "static/nodejs-69b5368f99170d00a2fec67f72075e80.png";